



















































import {Component, Mixins} from "vue-property-decorator";
import Http from "@/mixins/http";
import Toast from "@/mixins/toast";
import Card from "@/components/UI/Card.vue";

import {FileType} from "@/interfaces/server-data";
import FixedPricesView from './Tabs/FixedPricesView/FixedPricesView.vue';
import Results from './Tabs/Results/Results.vue';
import RevaluationQueue from './Tabs/RevaluationHistory/RevaluationHistory.vue';
import MarketSelect from "@/components/MarketSelect.vue";
import {SelectMarket} from "@/interfaces/global-data";
import UploadFixedPricesFiles from "@/pages/FixedPrices/Tabs/UploadFixedPrices/UploadFixedPricesFiles.vue";

@Component({
  components: {
    UploadFixedPricesFiles,
    MarketSelect,
    Card,
    FixedPricesView,
    Results,
    RevaluationQueue,
  },
})
export default class FixedPricesCommon extends Mixins(Http, Toast) {
    fileType = FileType.FIXED_PRICE;

    activeTabKey: string = "viewFixedPrices";

    queueAndHistoryColumnsVisibility: {visible: string[], toShow: string[]} = {visible: [], toShow: []};

    fixedPriceFilesMarket = localStorage.getItem('fixed_price_files_market');
    selectMarket: SelectMarket | null = this.fixedPriceFilesMarket ? JSON.parse(this.fixedPriceFilesMarket) : null;

    updateSelectMarket(market: SelectMarket) {
        this.selectMarket = market;

        localStorage.setItem('fixed_price_files_market', JSON.stringify(market));
        this.$log.debug('Fixed Priced - updateSelectMarket', market);
    }

    handleToResultsTab() {
        this.activeTabKey = 'results';

        setTimeout(() => { (this.$refs.contentWrapper as HTMLElement).scrollIntoView({ behavior: "smooth" }); }, 500)
    }
}
